import { render, staticRenderFns } from "./PostingSupplyDetailForProductionScan.vue?vue&type=template&id=39bd3bd1&scoped=true&"
import script from "./PostingSupplyDetailForProductionScan.vue?vue&type=script&lang=js&"
export * from "./PostingSupplyDetailForProductionScan.vue?vue&type=script&lang=js&"
import style0 from "./PostingSupplyDetailForProductionScan.vue?vue&type=style&index=0&id=39bd3bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd3bd1",
  null
  
)

export default component.exports